import React, { useState, useEffect } from 'react';
import { employeesAPI } from '../../services/api';

const ReassignModal = ({ employee, onClose, onConfirm }) => {
  const [activeEmployees, setActiveEmployees] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [empRes, countRes] = await Promise.all([
          employeesAPI.getAllEmployees(),
          employeesAPI.getAssignedCount(employee.id)
        ]);
        const others = (empRes.data || []).filter(
          e => e.id !== employee.id && e.status === 'ACTIVE'
        );
        setActiveEmployees(others);
        setCounts(countRes.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [employee.id]);

  const total = counts ? Object.values(counts).reduce((a, b) => a + b, 0) : 0;

  const handleConfirm = async () => {
    if (!selectedId) return;
    setConfirming(true);
    try {
      await employeesAPI.reassignAndInactivate(employee.id, selectedId);
      onConfirm();
    } catch (e) {
      console.error(e);
    } finally {
      setConfirming(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-[2px] flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Deactivate {employee.name}</h2>
        <p className="text-sm text-gray-500 mb-4">This employee has assigned records that must be reassigned before deactivation.</p>

        {loading ? (
          <p className="text-sm text-gray-400">Loading...</p>
        ) : (
          <>
            <div className="bg-gray-50 rounded-xl p-4 mb-4 grid grid-cols-2 gap-3">
              {counts && Object.entries(counts).map(([key, val]) => (
                <div key={key} className="text-center">
                  <p className="text-2xl font-bold" style={{ color: '#3B5A67' }}>{val}</p>
                  <p className="text-xs text-gray-500 capitalize">{key}</p>
                </div>
              ))}
            </div>

            <p className="text-sm font-medium text-gray-700 mb-2">Reassign all {total} records to:</p>
            <select
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mb-6 focus:outline-none focus:ring-2"
              style={{ focusRingColor: '#3B5A67' }}
              value={selectedId}
              onChange={e => setSelectedId(e.target.value)}
            >
              <option value="">Select team member...</option>
              {activeEmployees.map(e => (
                <option key={e.id} value={e.id}>{e.name}</option>
              ))}
            </select>

            <div className="flex gap-3 justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={!selectedId || confirming}
                className="px-4 py-2 text-sm text-white rounded-lg disabled:opacity-50"
                style={{ backgroundColor: '#3B5A67' }}
              >
                {confirming ? 'Reassigning...' : 'Reassign & Deactivate'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReassignModal;
